import React, { useContext, useMemo } from 'react'
import { MainTopLeft, MainTopTitle } from '@/components/Layout'
import { PersistenceIndicator } from '@/components/changeRequests/persistenceIndicator'
import { ApprovalSummary } from '@/components/changeRequests/approvalSummary'
import { FormContext } from '@/components/changeRequests/formContext'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import { Badge } from 'reactstrap'
import { getTargetUrl } from '@/components/changeRequests/urls'

export function ScopeDetailHeader ({ title, editButtonText, origLinkText, backUrl, children, isClassCompany, hasValidStatus }) {
  const { uid, scope, isChangeItemId, changeItemId, targetId } = useContext(FormContext)
  const isParentMergedCompany = !hasValidStatus && isClassCompany
  const showEdit = useMemo(() => (isClassCompany === undefined && hasValidStatus === undefined) || (hasValidStatus || isParentMergedCompany), [isClassCompany, hasValidStatus, isParentMergedCompany])

  return (
    <Resx render={({ localize }) =>
      <React.Fragment>
        <MainTopTitle backUrl={backUrl}>
          <PersistenceIndicator uid={uid} />
          {localize(title)}
          {/* TODO: RRE styling */}
          <span style={{ borderLeft: '1px solid #ccc', marginLeft: 5 }}> {children}</span>
        </MainTopTitle>
        <MainTopLeft>
          {!isChangeItemId
            ? (changeItemId
              ? (showEdit) && <Link id='editEntry' to={`/${scope}/~${changeItemId}`}>{localize(editButtonText || 'Common.Edit')}</Link>
              : (showEdit) && <CreateChangeItem isClassCompany={isClassCompany} buttonText={editButtonText || 'Common.Edit'} scope={scope} targetId={targetId} />)
            : (
              <React.Fragment>
                <Badge pill color='primary'><Resx name='Tasks.PartOfChangeRequest' /></Badge>
                <ApprovalSummary uid={uid} />&nbsp;
                {!!targetId && <Link to={getTargetUrl(scope, targetId)}>{localize(origLinkText || 'Tasks.GoToOriginal')}</Link>}
              </React.Fragment>
            )
          }
        </MainTopLeft>
      </React.Fragment>
    } />
  )
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/scopeDetailHeader.js